import { api } from '@/core/lib/api-client';
import { LinkInBioDto, ModifyLinkInBioDto, ResponseType } from '@link-in-bio/domain';

export const modifyLinkInBio = (modifyLinkInBioDto: ModifyLinkInBioDto): Promise<ResponseType<LinkInBioDto>> => {
  return api.post(`/link-in-bio/modify/${modifyLinkInBioDto._id}`, modifyLinkInBioDto, {
    headers: {
      'x-allow-scripts': 'true',
    },
  });
};
